import Graylog from 'components/domain/analytics/Graylog/Graylog';
import { useActiveMember } from 'hooks';
import { useCallback, useMemo } from 'react';
import AnalyticsEvent from 'utils/constants/analytics/analyticsEvent';

function useAppSwitcherAnalytics() {
  const member = useActiveMember();

  const recordAppSwitcherIconClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.APP_SWITCHER_ICON_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordToolWatchLoginClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.TOOLWATCH_LOGIN_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordFleetWatcherLoginClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.FLEETWATCHER_LOGIN_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordSafetyReportsLoginClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.SAFETYREPORTS_LOGIN_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordBusyBusyLoginClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.BUSYBUSY_LOGIN_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordToolWatchLearnMoreClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.TOOLWATCH_LEARN_MORE_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordFleetWatcherLearnMoreClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.FLEETWATCHER_LEARN_MORE_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordSafetyReportsLearnMoreClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.SAFETYREPORTS_LEARN_MORE_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordBusyBusyLearnMoreClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.webAppSwitcher.BUSYBUSY_LEARN_MORE_CLICKED,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  return useMemo(
    () => ({
      recordAppSwitcherIconClick,
      recordToolWatchLoginClick,
      recordFleetWatcherLoginClick,
      recordSafetyReportsLoginClick,
      recordBusyBusyLoginClick,
      recordToolWatchLearnMoreClick,
      recordFleetWatcherLearnMoreClick,
      recordSafetyReportsLearnMoreClick,
      recordBusyBusyLearnMoreClick,
    }),
    [
      recordAppSwitcherIconClick,
      recordToolWatchLoginClick,
      recordFleetWatcherLoginClick,
      recordSafetyReportsLoginClick,
      recordBusyBusyLoginClick,
      recordToolWatchLearnMoreClick,
      recordFleetWatcherLearnMoreClick,
      recordSafetyReportsLearnMoreClick,
      recordBusyBusyLearnMoreClick,
    ]
  );
}

export default useAppSwitcherAnalytics;
